module.exports = __webpack_public_path__ + "img/sscore-img@2x.a7528a6a.png";